import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decodeDataforkey } from "./config/encodelocalstorage";
import { httpConfig } from "./httpConfig";
import { RequestFetch } from "./config/requestFetch";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";

const Pageconfirmshare = () => {
  const { docobj } = useParams();
  const navigat = useNavigate();
  const dataobjis = decodeDataforkey(atob(docobj));
  const [detaildatashare, setDetaildatashare] = useState(null);
  const [checkshowbtnclick, setCheckshowbtnclick] = useState(true);
  const [pinforcheck, setPinforcheck] = useState([]);
  const [pinis, setPinis] = useState(null);
  const [atoken, setAtoken] = useState(null);

  const docgetID = (id) => {
    return document.getElementById(id);
  };

  const handlegetdetaildata = async (obj) => {
    let objsend = {
      advisor_id: obj.shareiddoc,
      work_id: obj.workid,
    };
    await fetch(
      `${httpConfig()}/messageConfrimPage`,
      RequestFetch("POST", objsend)
    ).then((res) =>
      res.json().then((data) => {
        console.log("ข้อมูลที่จะนำมาแสดงคือ", data);
        setDetaildatashare(data);
        if (data) {
          let checkdatacancle;
          data.map((ele) => {
            if (ele.cancle === 0) {
              checkdatacancle = true;
            } else if (ele.cancle > 0) {
              checkdatacancle = false;
            }
          });
          setCheckshowbtnclick(checkdatacancle);
        }
      })
    );
  };

  const handlesetpinshow = () => {
    let result = "";
    let countlg = pinforcheck.length;
    if (countlg <= 6) {
      pinforcheck.map((ele) => {
        result = `${result}${ele}`;
      });
      console.log("result ->", result);
      setPinis(result);
    }
  };

  const handleslicepin = () => {
    let countlg = pinforcheck.length;
    if (countlg <= 1) {
      setPinis(null);
    } else {
      let cut = countlg - 1;
      let result = "";
      let arr_map = pinforcheck.slice(0, cut);
      arr_map.map((ele) => {
        result = `${result}${ele}`;
      });
      setPinforcheck(arr_map);
      setPinis(result);
    }
  };

  const handleClearreset = () => {
    setPinforcheck([]);
    setPinis(null);
  };

  const handleshowNoteAndConfirmPIN = () => {
    setTimeout(() => {
      docgetID("modelConfirmpin").style.display = "flex";
    }, 180);
  };

  const handlesetPINforcheck = (value) => {
    let countlg = pinforcheck.length;
    if (countlg < 6) {
      setPinforcheck((item) => [...item, value]);
    }
  };

  const handlechktokenforlogin = (pinis) => {
    fetch(`${httpConfig()}/login`, RequestFetch("POST", { pin: pinis })).then(
      (res) =>
        res.json((data) => {
          if (data) {
            if (data.token) {
              setAtoken(data.token);
            }
          }
        })
    );
  };

  //ตอนกดตอบรับและเช็ค PIN เรียบร้อยแล้ว
  const handleforConfrimshareingnow = (
    workid,
    own_docid,
    share_docid,
    usetoken
  ) => {
    let bodyfetch_workconfirm = {
      workid: workid,
      docown: own_docid,
      docshare: share_docid,
    };
    let bodyfetch_messageconfirm = {
      workID: workid,
      advisorID: share_docid,
    };
    fetch(
      `${httpConfig()}/messageconfirm`,
      RequestFetch("PUT", bodyfetch_messageconfirm, usetoken)
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then(() => {
            setAtoken(null);
          });
        } else {
          console.error("fail to fetch messageconfirm !!!");
          setAtoken(null);
        }
      })
      .catch((err) => {
        console.error("fail to fetch messageconfirm ::", err);
        setAtoken(null);
      });
    fetch(
      `${httpConfig()}/workconfirmshare`,
      RequestFetch("PUT", bodyfetch_workconfirm, usetoken)
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then(() => {
            setAtoken(null);
          });
        } else {
          console.error("fail to fetch workconfirmshare !!!");
          setAtoken(null);
        }
      })
      .catch((err) => {
        console.error("fail to fetch workconfirmshare ::", err);
        setAtoken(null);
      });
  };

  useEffect(() => {
    console.log("objparams is >>", dataobjis);
    handlegetdetaildata(dataobjis);
  }, []);

  useEffect(() => {
    if (!pinforcheck[0]) return;
    handlesetpinshow();
  }, [pinforcheck]);

  useEffect(() => {
    if (!checkshowbtnclick) {
      navigat("/page404");
    }
  }, [checkshowbtnclick]);

  useEffect(() => {
    if (!pinis || pinis.length < 6) return;
    if (pinis) {
      console.log("ตอนนี้ได้ PIN ที่กรอกมาเรียบร้อยแล้ว!!!", pinis);
      let objecttocheck = { id_advisor: dataobjis.ownId, pin_advisor: pinis };
      fetch(
        `${httpConfig()}/messageCheckPINadvisor`,
        RequestFetch("POST", objecttocheck)
      ).then((res) =>
        res.json().then((data) => {
          if (data) {
            if (data.status || data.status === true) {
              handlechktokenforlogin(pinis);
            } else {
              console.log(data.message);
            }
          }
        })
      );
    }
  }, [pinis]);

  useEffect(() => {
    if (!atoken) return;
    if (atoken) {
      handleforConfrimshareingnow(
        dataobjis.workid,
        dataobjis.ownId,
        dataobjis.shareiddoc,
        atoken
      );
    }
  }, [atoken]);

  return (
    <div className="content-page-confirmshare">
      <div className="title-note-pageconfirmshare">
        <span>{"คำขอฝากงานประเมิน"}</span>
      </div>
      <div className="boxbody-cardshowdetail-pageconfirmshare">
        <div className="iconshow">
          <div className="circlebox">
            <Icon
              onClick={() => {
                document.getElementById();
              }}
              className="iconletter"
              icon="clarity:email-solid"
            />
          </div>
        </div>
        <div className="headtitle">
          <b>{"ฝากงานประเมิน"}</b>
        </div>
        {detaildatashare
          ? detaildatashare.map((ele, key) => {
              if (ele.cancle !== 1) {
                return (
                  <div className="detail" key={key}>
                    <div>
                      <span>{`รายการประเมิน ${ele.sheetname}`}</span>
                    </div>
                    <div>
                      <span>{`การประเมินวันที่ ${moment(ele.date)
                        .add(543, "year")
                        .format("DD/MM/YYYY")} `}</span>
                    </div>
                    <div>
                      <span>{`จาก ${ele.share_ttl} ${ele.share_name} ${ele.share_lname}`}</span>
                    </div>
                  </div>
                );
              }
            })
          : ""}
        <div
          className="btn-showconfrim"
          style={checkshowbtnclick ? { display: "block" } : { display: "none" }}
        >
          <button
            type="button"
            onClick={() => {
              handleshowNoteAndConfirmPIN();
            }}
          >
            {"คลิกตอบรับการประเมิน"}
          </button>
        </div>
      </div>
      <div className="footer-content">
        <div className="noteshowdetail-footer">
          <span>{`หมายเหตุ : หากต้องการฝากงานกลับไปยังอาจารย์คนดังกล่าว 
              สามารถฝากงานได้บน เว็บไซต์การประเมิน Estimate`}</span>
        </div>
        <div className="credit-footer">
          <span>{"แบบตอบรับการยื่นฝากประเมิน จัดทำโดย "}</span>
          <a href="https://datasoft.co.th/estimate">
            {"©datasoft.co.th/estimate"}
          </a>
        </div>
      </div>
      <div className="model-confrimpin" id="modelConfirmpin">
        <div className="closerBoxmodel">
          <Icon
            onClick={() => {
              docgetID("modelConfirmpin").style.display = "none";
              setPinis(null);
              setPinforcheck([]);
            }}
            icon="mdi:window-close"
          />
        </div>
        <div className="formconfrimpin">
          <h2>{"ยืนยันตอบรับการประเมิน"}</h2>
          <div className="showpassword">
            <input
              type="password"
              placeholder="- - - - - -"
              defaultValue={pinis}
              readOnly
            ></input>
          </div>
          <div className="gridBoxnumber">
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("1");
              }}
            >
              {"1"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("2");
              }}
            >
              {"2"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("3");
              }}
            >
              {"3"}
            </button>
          </div>
          <div className="gridBoxnumber">
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("4");
              }}
            >
              {"4"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("5");
              }}
            >
              {"5"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("6");
              }}
            >
              {"6"}
            </button>
          </div>
          <div className="gridBoxnumber">
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("7");
              }}
            >
              {"7"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("8");
              }}
            >
              {"8"}
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("9");
              }}
            >
              {"9"}
            </button>
          </div>
          <div className="gridBoxnumber">
            <button
              type="button"
              onClick={() => {
                handleClearreset();
              }}
            >
              <Icon icon="system-uicons:reset-alt" />
            </button>
            <button
              type="button"
              onClick={() => {
                handlesetPINforcheck("0");
              }}
            >
              {"0"}
            </button>
            <button
              type="button"
              onClick={() => {
                handleslicepin();
              }}
            >
              <Icon icon="ep:back" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Pageconfirmshare;
